<div class="img" [class.tui-skeleton]="!src">
  <img [src]="src | safe: 'url'" [alt]="'common.labels.picture' | translate" width="100%" />
</div>
